// Piloto do novo visual de "Aproveite também" (lista compacta com fotos, promoção e economia) na etapa "Confirmar" da página pública.
//
// Mesmo padrão de config/paymentSelectorFlags.ts, com chave PRÓPRIA (liga/desliga independente do seletor de pagamento): a lista de empresas fica no
// CÓDIGO e a decisão usa o id da empresa CARREGADA na página (resposta de /public/:slug) — nunca o usuário logado nem parâmetros da URL.
// Sem empresa identificada = visual original. A liberação para todas as empresas depende de nova aprovação (companyIds: null).
// Para reverter só este piloto: enabled:false (ou companyIds:[]) e publicar de novo.

export interface AddonsListFlag {
  enabled: boolean;
  companyIds: number[] | null;
}

export const ADDONS_LIST_V2_FLAG: AddonsListFlag = { enabled: true, companyIds: [7] };

export function isAddonsListV2On(companyId: unknown, flag: AddonsListFlag = ADDONS_LIST_V2_FLAG): boolean {
  if (!flag.enabled) return false;
  if (typeof companyId !== 'number' && typeof companyId !== 'string') return false;
  if (typeof companyId === 'string' && !/^\d+$/.test(companyId.trim())) return false;
  const id = Number(companyId);
  if (!Number.isInteger(id) || id <= 0) return false; // empresa não identificada: visual original
  return flag.companyIds === null ? true : flag.companyIds.includes(id);
}
